export default "__VITE_ASSET__4NuDeEdv__"